import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { NotificationService } from '../services/notification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  private notificationService: NotificationService = inject(NotificationService);

  public isPanelOpen: boolean = false;
  private panelStateSubscription!: Subscription;


  ngOnInit() {
    this.panelStateSubscription = this.notificationService.isPanelOpen$.subscribe(
      (isOpen) => {
        this.isPanelOpen = isOpen;
        if (isOpen) {
          this.loadNotifications();
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.panelStateSubscription) {
      this.panelStateSubscription.unsubscribe();
    }
  }

  loadNotifications() {
    console.log('Cargando notificaciones...');
    // Aquí cargarías tu data real
  }

  closePanel() {
    this.notificationService.closePanel();
  }
}
